import { Section } from "@atoms/section";
import { Typography } from "@atoms/typography";
import { LayoutTemplate } from "@templates/layout";
import { FC } from "react";

export const PrivacyPolicyTemplate: FC = () => {
  return (
    <LayoutTemplate page="privacy-policy">
      <Section>
        <Typography variant="title1"></Typography>
        <div>
          <p>
            <strong>Feeling Home</strong> is committed to protecting the
            privacy of users on our website, <strong>Feeling Home</strong>.
            This privacy policy is intended to inform users of privacy practices
            and information collection processes implemented on this website.
          </p>
          <p>
            <strong>What personal information do we collect?</strong>
          </p>
          <p>
            We collect information from users on our site through the following
            means: site/account registration, order placement, newsletter
            subscriptions, surveys and forms. Any data requested that is not a
            requirement will be specified as optional. You may visit our website
            anonymously, however, account registration or order placement may
            require the following information: name, email address,
            mailing/billing address, phone number or credit card information.
          </p>
          <p>
            Personally-Identifiable Information: We do not rent or sell your
            personally identifiable information. Information may be stored
            outside of our website (for instance, on servers or databases
            co-located with hosting providers.) Information the user elects to
            make publicly identifiable on our site, such as blog comments or
            reviews, will be available to others.
          </p>
          <p>
            Non-Personally Identifiable Information: Non-personally identifiable
            information (such as anonymous usage data, referring/exit pages and
            URLs, platform types, number of clicks, etc.) may be collected.
          </p>
          <p>
            <strong>How and why we collect information:</strong>
          </p>
          <p>
            A cookie is a small and unique text file that websites send to your
            computer upon visiting a site. The use of cookies is implemented on
            this site to provide a personalized user experience. The use of
            cookies allows us to track website visits and gather basic user
            information.
          </p>
          <p>
            Cookies necessary for basic function of the site do not store
            personal data. This means site visitors can engage in many
            activities on the site without providing personal information.
          </p>
          <p>
            Cookies used on this site can be categorized in the following ways:
          </p>
          <p>
            <u>Necessary cookies</u> (As described above, these are used
            for the basic function of the site and do not store personal data)
          </p>
          <p>
            <u>Performance cookies</u> ( In general, these cookies do not
            collect personal data and collect information about how the site is
            used)
          </p>
          <p>
            <u>Functionality cookies</u> (These cookies collect information
            regarding choices elected on the site, such as State/Region. These
            cookies remember selections you?ve made on the site to customize
            your experience.)
          </p>
          <p>
            <u>Targeting cookies</u> (Primarily used by advertising
            networks to collect information surrounding browsing habits.)
          </p>
          <p>
            <u>Social Media cookies</u> (Cookies implemented when site
            visitor utilizes ?sharing? buttons, allowing the user to share
            content)
          </p>
          <p>
            <strong>How we use information:</strong>
          </p>
          <p>
            Cookies are utilized on our website to better serve the end user, as
            well as for site analytics. Personally identifiable information is
            supplied by the customer and used for online transactions, marketing
            etc. Non-personally identifiable information is used primarily for
            analytics of the site. This allows us to improve our services,
            analyze how the website is used (specifically how users access and
            utilize the website.) This information is not used to profile those
            who access our website.
          </p>
          <p>
            The following includes ways in which information collected may be
            used: user experience, website improvements, promotions, surveys,
            transactions, periodic marketing emails, emails pertaining to
            transactions/orders.
          </p>
          <p>
            <strong>How we secure your information:</strong>
          </p>
          <p>
            Security measures are implemented to ensure safety of personal
            information entered, submited or obtained through this website.
            Measures include:
          </p>
          <ul>
            <li>
              SSL (Secure Socket Layer) Technology &amp; Encryption for
              sensitive/payment information
            </li>
            <li>
              Secure Server Protocol (HTTPS) - Our secure servers do not store
              private information such as credit card, billing information etc.
            </li>
            <li>
              Content Management System (CMS) utilizes password encryption.
            </li>
          </ul>
          <p>
            <strong>Third Party Access:</strong>
          </p>
          <p>
            When your personal data is collected on the site, it may be shared
            with selected third parties who assist with business operations such
            as marketing or advertising campaigns, or in delivery of
            functionality and features requested by user.
          </p>
          <p>
            <strong>Contact:</strong>
          </p>
          <p>
            Contact us at any time to request information that we have about
            you, correct any of the information or delete any of the
            information. We may be contacted through the contact form on this
            website.
          </p>
          <p>
            <strong>GDPR-Specific Information for EU Users:</strong>
          </p>
          <p>
            Not all services provided on this website require registration,
            allowing users to visit this site without providing personal data.
            However, some services of the site may require that personal data is
            provided. If required personal data is withheld, the user may not be
            able to gain access to certain parts of the site or allow us to
            properly respond to your query. International Transfer: If you are
            located where GDPR applies, information that we collect (including
            through cookies) will be processed and stored in the United States.
          </p>
          <p>
            Our legal basis for processing data: The data subject has given
            consent to the processing of his or her personal data for one or
            more specific purposes.
          </p>
        </div>
      </Section>
    </LayoutTemplate>
  );
};
